import { useQuery } from "@tanstack/react-query";

import { api } from "@/config/api";
import { queryKeys } from "@/hooks/queries";
import type { AchievementsResponse, ApiResponse } from "@/types";

interface AchievementsApiResponse extends ApiResponse {
  achievements: AchievementsResponse;
}

export function useAchievements() {
  return useQuery({
    queryKey: queryKeys.achievements,
    queryFn: () => api.get<AchievementsApiResponse>("/api/achievements"),
    select: (data) => data.achievements,
  });
}
